export const Z = {
  BOTTOM_NAV: 100,
  DROPDOWN: 200,
  MODAL: 300,
  FILE_DROPZONE: 400,
  ALERTS: 500,
} as const
